import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant5PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 1041 972",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M970.157 766.819C909.89 808.814 848.997 851.166 781.091 879.178C756.698 889.23 731.277 897.45 705.053 900.309C678.828 903.169 651.576 900.488 627.541 889.542C592.069 873.37 565.576 838.836 559.143 800.37C544.891 714.861 627.049 657.677 684.323 610.41C729.133 573.463 771.753 530.351 791.5 475.758C811.247 421.164 802.401 352.722 757.368 315.998C721.762 286.959 669.893 283.162 626.781 298.888C583.625 314.658 548.51 347.539 521.794 384.933C474.349 451.276 450.983 531.245 425.25 608.578C398.802 688.101 366.547 782.991 295.736 833.877C261.246 858.672 215.722 870.957 175.335 857.912C136.736 845.448 107.741 811.628 92.641 773.967C31.4356 621.936 108.814 441.76 203.972 321.672C284.344 220.303 389.063 141.004 497.49 70.417",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant5PathwayIllustration as default };
